<template>
  <!-- Main row with participant info -->
  <div class=" border-b border-border-light cursor-pointer" :class="{
    'bg-yellow-50 transition-colors duration-1000': leaderboardRankUpdated,

  }">


    <div class="grid grid-cols-12 items-center text-xs font-medium" @click.stop="internalShowHand = !internalShowHand">
      <!-- Rank number -->
      <div class="col-span-2 py-4 text-right flex items-center justify-between">
        <AppExpandCollapse @click.stop v-model="internalShowHand" :showLabel="false" />

        <span v-if="item.rank.cardCount > 0" class="px-2 py-1 text-right">
          {{ item.position }}.
        </span>
        <span v-else class="text-right">n/a</span>
      </div>

      <!-- Participant name -->
      <div class="col-span-5 py-4 pl-1  ">
        {{ item.participantName }}
      </div>

      <!-- Hand type -->
      <div class="col-span-4 py-4 text-right ">
        {{ translateRankType(item.rank.rankType) }}
      </div>
    </div>
    <template v-if="internalShowHand">

      <!-- Expanded row with cards -->
      <div class="border-b border-border-light py-4 px-4 "
        :class="{ 'bg-yellow-50 transition-colors duration-1000': leaderboardRankUpdated }">
        <div class="flex justify-center">
          <RankHand :participant-id="item.participantId" :cards="getCards(item.rank)" :card-count="itemRef.extraCard
            ? itemRef.participantCardCount
            : itemRef.participantCardCount - 1
            "></RankHand>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef, watch } from "vue";
import RankHand from "@/components/RankHand.vue";
import { Rank } from "@models/Rank";
import { LeaderboardItem } from "@models/LeaderboardItem";
import useHandRank from "@/modules/useHandRank";
import Accordion from "./Accordion.vue";

const { translateRankType } = useHandRank();

interface Props {
  item: LeaderboardItem;
  showHand: boolean;
}

const props = defineProps<Props>();
const leaderboardRankUpdated = ref(false);
const itemRef = toRef(props, "item");
const internalShowHand = ref(props.showHand);

// Watch for changes in the item data
watch(itemRef, (newValue: LeaderboardItem, oldValue: LeaderboardItem) => {
  if (
    newValue.position !== oldValue.position ||
    newValue.rank.rankType !== oldValue.rank.rankType
  ) {
    leaderboardRankUpdated.value = true;
    setTimeout(() => (leaderboardRankUpdated.value = false), 100);
  }
});

// Watch for changes in the showHand prop
watch(() => props.showHand, (newValue) => {
  internalShowHand.value = newValue;
});

const getCards = (rank: Rank) => {
  const allCards = [...rank.rankCards, ...rank.kickerCards, ...rank.extraCards];

  if (!itemRef.value.extraCard && allCards.length > 5) {
    allCards.splice(5, 1);
  }
  return allCards;
};
</script>
